type PatientNameModel = { patientName: string; patientIdentifier: number | string };

export function RenderPatientNameNameCell({ patient }: { patient: PatientNameModel | undefined }) {
	if (!patient) {
		return null;
	}
	return (
		<div className="flex flex-col">
			<div className="flex items-center gap-2">
				<span className="text-sm text-gray-900">{patient.patientName}</span>
			</div>
			<p className="mt-1 max-w-xs truncate text-xs text-gray-500">MR#: {patient.patientIdentifier}</p>
		</div>
	);
}
